import { sharedEffects } from 'shared-lib'
import * as sellerItemEffects from './seller-item/seller-item.effects'
import * as sellerApplicationEffects from './seller-application/seller-application.effects'
export const effects = { ...sharedEffects, ...sellerItemEffects, ...sellerApplicationEffects }
